import * as PIXI from "pixi.js";
import gsap from "gsap";

import { Popup } from "@src/core/ui/components/Popup";
import { Button } from "@src/core/ui/components/Button";
import { constants } from "@src/game/Constants";
import { EventSystem } from "@src/core/events/EventSystem";
import { gameEngine } from "@src/game/GameEngine";

export class AutoplayPopup extends Popup {
  protected title: string = "";
  public width: number = 0;
  public height: number = 0;

  private COLUMNS: number = 0;
  private _selectAutoplayButtons: Button[] = [];

  protected initializeComponents(): void {
    this.title = "Autoplay";
    this.width = 700;
    this.height = 700;

    this.COLUMNS = 3;
    this._selectAutoplayButtons = [];

    super.initializeComponents();
  }

  protected initializeContent(): void {
    if (this._selectAutoplayButtons.length > 0) {
      return;
    }

    // TODO: Get the real bet array from the server response
    const dummyAutoplayArray: string[] = [
      "10",
      "20",
      "30",
      "50",
      "100",
      "250",
      "500",
      "∞",
    ];

    const rows: number = Math.ceil(dummyAutoplayArray.length / this.COLUMNS);

    // Calculate button size and spacing based on content area
    const buttonSpacing: number = 20;
    const availableWidth: number =
      this.contentSizeX - buttonSpacing * (this.COLUMNS - 1);
    const buttonWidth: number = availableWidth / this.COLUMNS;
    const buttonHeight: number = 70;

    // Calculate total height used by the grid
    const totalGridHeight: number =
      rows * buttonHeight + (rows - 1) * buttonSpacing;

    // Start from TOP-LEFT of content area, but offset to center vertically
    const startX: number = -this.contentSizeX / 2 + buttonWidth / 2;
    const startY: number = -totalGridHeight / 2 + buttonHeight / 2; // Center the grid vertically

    for (let i = 0; i < dummyAutoplayArray.length; i++) {
      const autoplayAmount: string = dummyAutoplayArray[i];
      const row: number = Math.floor(i / this.COLUMNS);
      const column: number = i % this.COLUMNS;

      const selectBetButton = this._createSelectAutoplayButton(
        buttonWidth,
        buttonHeight,
        autoplayAmount,
      );
      selectBetButton.setActive(false);
      this._selectAutoplayButtons.push(selectBetButton);

      // Position from top-left, left-to-right
      const x = startX + column * (buttonWidth + buttonSpacing);
      const y = startY + row * (buttonHeight + buttonSpacing);

      selectBetButton.view.position.set(x, y);
      this.content.addChild(selectBetButton.view);
    }

    this._selectAutoplayButtons.forEach((button: Button, i: number) => {
      const btns = this._selectAutoplayButtons;
      button.onClick = () => {
        btns.forEach((button) => {
          button.setActive(false)
          console.log("set button to disabled");
        });

        button.setActive(true);

        const autoplayValue = dummyAutoplayArray[i];

        if (autoplayValue === "∞") {
          EventSystem.invoke(
            constants.UIEvents.SELECTED_AUTOPLAY_COUNT, autoplayValue);
        } else {
          EventSystem.invoke(
            constants.UIEvents.SELECTED_AUTOPLAY_COUNT, parseInt(autoplayValue, 10));
        }
      };
    });

    super.initializeContent();
  }

  public resetButtons(): void {
    const btns = this.view.children[2].children;
    console.log(btns);
    btns.forEach((container: any) => {
      const buttonInstance = (container as any).buttonInstance;
      if (buttonInstance) {
        buttonInstance.setActive(false);
        console.log("set button inactive");
      }
    });
  }

  private _createSelectAutoplayButton(
    width: number,
    height: number,
    autoplayValue: string,
  ): Button {
    const buttonBackgroundActive: PIXI.Graphics = new PIXI.Graphics();
    buttonBackgroundActive.roundRect(
      -width / 2,
      -height / 2,
      width,
      height,
      height / 2,
    );
    buttonBackgroundActive.stroke({ width: 3, color: 0xffffff });

    const buttonBackgroundInactive: PIXI.Graphics = new PIXI.Graphics();
    buttonBackgroundInactive.roundRect(
      -width / 2,
      -height / 2,
      width,
      height,
      height / 2,
    );
    // NOTE: In pixijs, if a graphics object doesnt have a fill property
    // than it can not be clicked
    // We utilize that functionality to make already selected buttons unselectable
    buttonBackgroundInactive.fill(0x000000);
    buttonBackgroundInactive.stroke({ width: 3, color: 0x333333 });

    const autoplayLabel = new PIXI.Text({
      text: autoplayValue,
      style: {
        fill: "#ffffff",
        fontSize: 30,
        fontWeight: "bold",
        fontFamily: "uiFont",
        align: "center",
      },
    });
    autoplayLabel.anchor.set(0.5);

    const selectAutoplayButton: Button = new Button(
      constants.UIButtonTypes.POPUP_BUTTON,
    );
    selectAutoplayButton.activeGraphics = buttonBackgroundActive;
    selectAutoplayButton.inactiveGraphics = buttonBackgroundInactive;

    if (!(selectAutoplayButton.view as any).buttonInstance) {
      (selectAutoplayButton.view as any).buttonInstance = selectAutoplayButton;
    }
    selectAutoplayButton.view.addChild(autoplayLabel);

    return selectAutoplayButton;
  }
}
